import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../common/membershipFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'cotYarn',
    type: 'text',
    label: 'Total Cotton Yarn(kg)',
  },
  {
    colSpan: 1,
    name: 'synthYarn',
    type: 'text',
    label: 'Total Synthetic Yarn(kg)',
  },
  {
    colSpan: 1,
    name: 'otherYarn',
    type: 'text',
    label: 'Total Other Yarn(kg)',
  },
];

export const fabRawMatFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label).nullable(),
  [fields[1].name]: yup.string().label(fields[1].label).nullable(),
  [fields[2].name]: yup.string().label(fields[2].label).nullable(),
};

const FabRawMaterial = (props) => {
  return (
    <FormSection
      sectionName="Raw Material Requirement"
      sectionColumn={3}
      formFields={fields}
      {...props}
    />
  );
};

export default FabRawMaterial;
